import { Pipe, PipeTransform } from '@angular/core';

import { PrivaLocalizationService } from '@priva/localization';

import { KpiLimit } from 'app/kpi-notification-settings/kpi-notification-settings.model';

@Pipe({
    name: 'getTitle',
    standalone: true,
})
export class GetTitlePipe implements PipeTransform {
    constructor(private readonly translate: PrivaLocalizationService) {}

    transform(index: number, kpiSetLimits: KpiLimit[]): string {
        return index < kpiSetLimits.length
            ? kpiSetLimits[index].title
            : this.translate.instant('REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.UNGROUPED.KPISET');
    }
}
